import { FC, useContext, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import FooterText from "../../components/footerText";
import HubInputField from "../../components/inputType";

import useFetch from "../../hooks/useFetch";
import { ToastContext } from "../../context/toastContext";
import { forgotpasswordSchema } from "../../validation/forgotPassword";
import { APIEndpoints } from "../../types/apiTypes";
import { ToastTypes } from "../../types";
import { ForgotPasswordResponseType } from "./types";
import { LoaderContext } from "../../context/loaderContext";
import {Link} from "react-router-dom";
import {PHONE_NUMBER} from "../../constants/contact";
import {paciraLogo} from "../../assets";
import Footer from "../../components/footer";

const HubForgotPassword: FC = (): JSX.Element => {
  const { control, handleSubmit, reset } = useForm({
    mode: 'all',
    resolver: yupResolver(forgotpasswordSchema),
  });
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);





  const { loading, error, data, mutate, removeErrorAndData } = useFetch<null, null, ForgotPasswordResponseType>(APIEndpoints.USER_FORGOT_PASSWORD);

  useEffect(() => {
    if (data || error) {
      hideLoader();
      if (data) {
        const { message } = data;
        showToast([message], ToastTypes.SUCCESS);
        reset();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, error]);

  const submitForm = async (values: { email: string }) => {
    setLoader();
    if ((error && error.length > 0) || data) removeErrorAndData();

    mutate({ user: values });
  };




  return (
    <div className="container-fluid login-sec d-flex flex-fill flex-column justify-content-between overflow-auto">
      <div className="container d-flex flex-fill flex-column align-items-center pt-4 pb-4 ps-4 pe-4">
        <div className="row justify-content-center align-items-center flex-fill mb-3">
          <div className="col-12 col-lg-6 col-md-5">
            <h1 className="login-text">Keeping more of their recovery in your hands</h1>
          </div>
          <div className="col-12 col-lg-2 col-md-1"></div>
          <div className="col-12 col-lg-4 col-md-6">
            <form className="card shadow" onSubmit={handleSubmit(submitForm)}>
              <div className="card-header">
                <h3 className="m-0">Forgot Your Password?</h3>
              </div>

              <div className="card-body">
                <form onSubmit={handleSubmit(submitForm)} className="forgot-formlabel">
                  <Controller
                      name="email"
                      control={control}
                      defaultValue=""
                      render={({field, fieldState: {error}}) => (
                          <HubInputField
                              inputId="email"
                              isRowBased={false}
                              isRequired={true}
                              field={field}
                              error={error}
                              inputLabel="Email"
                              inputType="email"
                          />
                      )}
                  />

                </form>
                <p className="small m-0">By clicking sign in below, you agree to our&nbsp;
                  <a href="https://www.exparelpro.com/terms-of-use" target="_blank" rel="noreferrer">
                    Terms of Use
                  </a>
                </p>
              </div>

              <div className="card-footer d-flex align-items-center justify-content-between">
                <button disabled={loading} className="btn btn-primary" type="submit">
                  {loading ? (<i className="spinner-border me-2"></i>) : null}
                  Send me reset password instruction
                </button>
              </div>
            </form>
          </div>
        </div>
        <div>
          <p className="mb-3 text-white" style={{ fontSize: '1rem' }}>
            For more information, please visit&nbsp;
            <a target="_blank" className="text-secondary" href="https://www.exparelpro.com"
               rel="noreferrer">www.exparelpro.com</a>&nbsp;
            or call {PHONE_NUMBER}. You are encouraged to report negative side effects of prescription drugs to
            FDA; visit&nbsp;
            <a target="_blank" className="text-secondary" href="http://www.fda.gov/medwatch" rel="noreferrer">
              MedWatch: FDA Safety Information & Adverse Event Reporting Program
            </a>&nbsp;
            or call 1-800-FDA-1088.
          </p>
          <div className="row align-items-center">
            <div className="col-12 col-sm-2">
              <img className="img-fluid" width={170} src={paciraLogo} alt="Products Logos" />
            </div>
            <p className="col text-white m-0" style={{ fontSize: '1rem' }}>
              © 2026 Pacira Pharmaceuticals, Inc., a wholly owned subsidiary of Pacira BioSciences, Inc. EXPAREL is a
              registered trademark of Pacira Therapeutics, Inc. PP-EX-US-9728 May 2026
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default HubForgotPassword;
